module.exports = __webpack_public_path__ + "static/aftermovie-787e81ba237b89e15b7e2017cacfff41.mp4";